import type { ThemeComponentType } from 'theme/types';
import { Accordion } from './Accordion';
import { ActionIcon } from './ActionIcon';
import { Alert } from './Alert';
import { Anchor } from './Anchor';
import { Avatar } from './Avatar';
import { Badge } from './Badge';
import { Button } from './Button';
import { Calendar } from './Calendar';
import { Checkbox } from './Checkbox';
import { Code } from './Code';
import { Container } from './Container';
import { Divider } from './Divider';
import { Drawer } from './Drawer';
import { Dropzone } from './Dropzone';
import { Input } from './Input';
import { InputWrapper } from './InputWrapper';
import { Menu } from './Menu';
import { Modal } from './Modal';
import { MultiSelect } from './MultiSelect';
import { NativeSelect } from './NativeSelect';
import { Navbar } from './Navbar';
import { NavLink } from './NavLink';
import { Notification } from './Notification';
import { NumberInput } from './NumberInput';
import { Pagination } from './Pagination';
import { Paper } from './Paper';
import { Popover } from './Popover';
import { Radio } from './Radio';
import { ScrollArea } from './ScrollArea';
import { Select } from './Select';
import { Skeleton } from './Skeleton';
import { Table } from './Table';
import { Tabs } from './Tabs';
import { Text } from './Text';
import { Textarea } from './Textarea';
import { TimeInput } from './TimeInput';
import { Tooltip } from './Tooltip';
import { UnstyledButton } from './UnstyledButton';

export const components: Record<string, ThemeComponentType> = {
  Accordion,
  ActionIcon,
  Alert,
  Anchor,
  Autocomplete: Select,
  Avatar,
  Badge,
  Button,
  Calendar,
  Checkbox,
  Code,
  Container,
  DatePicker: Calendar,
  Divider,
  Drawer,
  Dropzone,
  Input,
  InputWrapper,
  Menu,
  Modal,
  MultiSelect,
  NativeSelect,
  NavLink,
  Navbar,
  Notification,
  NumberInput,
  Pagination,
  Paper,
  Popover,
  Radio,
  RangeCalendar: Calendar,
  ScrollArea,
  Select,
  Skeleton,
  Table,
  Tabs,
  Text,
  Textarea,
  TimeInput,
  Tooltip,
  UnstyledButton,
};
